import * as Sentry from "@sentry/remix";
/**
 * By default, Remix will handle hydrating your app on the client for you.
 * You are free to delete this file if you'd like to, but if you ever want it revealed again, you can run `npx remix reveal` ✨
 * For more information, see https://remix.run/file-conventions/entry.client
 */

import { RemixBrowser, useLocation, useMatches } from "@remix-run/react";
import { startTransition, StrictMode, useEffect } from "react";
import { hydrateRoot } from "react-dom/client";
import { posthog } from "posthog-js";

Sentry.init({
  dsn: "https://5a8da001b1ea1abb07f9b62cff0fbbf7@o4508345776537600.ingest.us.sentry.io/4508345777848320",
  tracesSampleRate: 1,
  environment: process.env.NODE_ENV,
  enabled: process.env.NODE_ENV === "production",

  integrations: [
    Sentry.captureConsoleIntegration(),
    Sentry.browserTracingIntegration({
      useEffect,
      useLocation,
      useMatches,
    }),
  ],
});

function PosthogInit() {
  useEffect(() => {
    posthog.init("phc_YlAxrAHhFOEmoAgYqVZeeVJ5Do9aEHHgv6vKXiE2ROC", {
      api_host: "https://us.i.posthog.com",
      person_profiles: "always", // or 'always' to create profiles for anonymous users as well
      loaded: (ph) => {
        if (window.location.hostname === "localhost") {
          ph.opt_out_capturing(); // opts a user out of event capture
          ph.set_config({ disable_session_recording: true });
        }
      },
    });
  }, []);

  return null;
}

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <RemixBrowser />
      <PosthogInit />
    </StrictMode>
  );
});
